<template>
    <header class="header">
        <div class="header__wrapper">
            <router-link
                to="/"
                tag="img"
                class="header__logo"
                :src="require('@/assets/'+$root.t(theme == 'bradesco' ? 'themes/bradesco/images/logo-white.png' : 'images/logo.png'))"
            ></router-link>
            <div v-if="isSmartfit()" class="header__items">
                <a
                    class="header__item"
                    :href="`https://${smartFitSite}/locations`"
                >{{ $root.t("Unidades") }}</a>
                <a
                    class="header__item"
                    :href="`https://${smartFitSite}/person_sessions/new`"
                >{{ $root.t("Espaço do Aluno") }}</a>
                <a
                    v-if="locale === 'br'"
                    class="header__item"
                    :href="'http://conteudo.smartfit.com.br/'"
                >{{ $root.t('Smart Fit News') }}</a>
            </div>
            <div
                v-if="theme != 'bradesco'"
                @click="openMenu()"
                class="header__menu"
                :style="
                    `background-image: url('${require('@/assets/' +
                        $root.t('images/menu-icon.png'))}');`
                "
            ></div>
        </div>
        <div class="menu" :class="{ active: showMenu }">
            <div class="menu__wrapper">
                <img
                    @click="closeMenu()"
                    class="menu__close"
                    :src="require(`@/assets/${$root.t('images/close-menu-black.png')}`)"
                />
                <ul class="menu__content">
                    <li
                        class="menu__item"
                        v-for="(menuItem, index) in menuItems"
                        :key="index"
                        @click="closeMenu()"
                    >
                        <router-link
                            v-if="menuItem.innerLink"
                            class="menu__link"
                            :to="menuItem.innerLink"
                        >
                            {{ menuItem.name }}
                        </router-link>
                        <a
                            v-if="menuItem.outerLink"
                            class="menu__link"
                            :href="`https://${smartFitSite}/${menuItem.outerLink}`"
                        >{{ menuItem.name }}</a>
                    </li>
                    <li class="menu__item" v-if="isSmartfit() && locale === 'br'">
                        <a
                            class="menu__link"
                            :href="'https://conteudo.smartfit.com.br/'"
                        >{{ this.$root.t("Conteúdo") }}</a>
                    </li>
                    <li class="menu__item" v-if="atBrazil()" @click="closeMenu()">
                        <router-link class="menu__link" to="/kits">
                            {{ $root.t("Kits") }}
                        </router-link>
                    </li>
                    <li class="menu__item" v-if="isSmartfit()">
                        <img
                            class="menu__link menu__link--icon"
                            :src="require(`@/assets/${$root.t('images/faq-icon.png')}`)"
                        >
                        <a
                            class="menu__link menu__link--faq"
                            :href="`https://${smartFitSite}/${faqSlug()}`"
                        >{{ this.$root.t("Dúvidas Frequentes") }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            showMenu: false,
            menuItems: [
                {
                    name: this.$root.t("Home"),
                    innerLink: "/"
                }
            ],
            smartFitSite: ""
        };
    },
    computed: {
        ...mapGetters(["theme", "locale"])
    },
    methods: {
        openMenu() {
            this.showMenu = true;
            document.body.classList.add('menu-open');
        },
        closeMenu() {
            this.showMenu = false;
            document.body.classList.remove('menu-open');
        },
        gaLogoEvent() {
            if (this.theme === "bioritmo") {
                this.$gtm.trackEvent({
                    event: "gaEvent",
                    eventCategory: `treine-em-casa-${this.theme}`,
                    eventAction: "logo-header",
                    eventLabel: ""
                });
            }
        },
        atBrazil() {
            const brazillianLocales = ["br", "bioritmo"];
            return brazillianLocales.includes(this.locale);
        },
        isSmartfit() {
            return this.theme === 'smartfit';
        },
        setSmartFitSite() {
            const hostLocale =
                window.location.host === "localhost"
                    ? this.locale
                    : window.location.host.slice(-2);

            this.smartFitSite =
                hostLocale === "cl"
                    ? `www.smartfit.${hostLocale}`
                    : `www.smartfit.com.${hostLocale}`;
        },
        setHeaderMenuItems() {
            if (this.isSmartfit()) {
                this.menuItems = [
                    ...this.menuItems,
                    {
                        name: this.$root.t("Unidades"),
                        outerLink: "locations"
                    },
                    {
                        name: this.$root.t("Planos"),
                        outerLink: "plans"
                    },
                    {
                        name: this.$root.t("Conceito Smart Fit"),
                        outerLink: "abouts"
                    },
                    {
                        name: this.$root.t("Espaço do Aluno"),
                        outerLink: "person_sessions/new"
                    }
                ];
            }
        },
        faqSlug() {
            return this.locale === "br" ? "coronavirus" : "faq";
        }
    },
    created() {
        this.setHeaderMenuItems();
        this.setSmartFitSite();
    }
};
</script>

<style lang="scss" scoped>
.header {
    background-color: #000;
    z-index: 999;
    height: 93px;

    &--menu-active {
        display: flex;
        flex-direction: column;
        position: fixed;
        width: 100%;
        height: 100%;
    }

    &__logo {
        height: 73px;
        width: auto;
        cursor: pointer;
    }

    &__wrapper {
        max-width: 1240px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        padding: 10px 15px;
        width: 100%;
    }

    &__items {
        font-size: 18px;
        display: none;

        @media (min-width: 900px) {
            display: flex;
        }
    }

    &__item {
        padding: 0 30px;
    }

    &__link {
        display: none;

        @media (min-width: 576px) {
            display: block;
        }
    }

    &__menu {
        background-size: contain;
        background-repeat: no-repeat;
        width: 24px;
        height: 24px;
        cursor: pointer;

        @media (min-width: 600px) {
            width: 36px;
            height: 36px;
        }
    }
}

.menu {
    width: 100%;
    height: 100%;
    background: #fafafa;
    opacity: 0;
    transition: all 0.6s;
    pointer-events: none;
    position: fixed;

    @media (min-width: 900px) {
        background: rgba(0,0,0,.5);
        top: 0;
        right: 0;
    }

    &.active {
        opacity: 1;
        pointer-events: all;
    }

    &__close {
        margin: 20px 15px 10px;
        align-self: flex-end;
        width: 24px;
        height: 24px;
        cursor: pointer;

        @media (min-width: 600px) {
            width: 36px;
            height: 36px;
            margin: 20px 15px;
        }
    }

    &__wrapper {
        max-width: 1240px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;

        @media (min-width: 900px) {
            padding: 20px;
            background: white;
            position: absolute;
            width: 100%;
            right: 0;
            height: 100%;
            max-width: 600px;
        }
    }

    &__content {
        margin: 0;
        font-size: 26px;
        padding: 0 0 0 50px;
        width: 100%;
        list-style-type: none;
    }

    &__link {
        color: black;

        &--icon {
            width: 54px;

            @media (min-width: 600px) {
                width: 72px;
            }
        }

        &--faq {
            color: #9a9c9e;
        }
    }

    &__item {
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        font-size: 16px;

        @media (min-width: 375px) {
            font-size: 18px;
        }

        @media (min-width: 600px) {
            padding: 15px 0;
            font-size: 26px;
        }
    }
}
</style>
